<template>
    <div class="courseSelector">
        <div class="courseSelector__container">
            <div>
                <h2 class="courseSelector__headline">{{ $t("formHeadlineCoursePlus") }}</h2>
                <div class="courseSelector__selector" v-for="selectedCourse, index in selectedCourses" :key="index">
                    <select class="courseSelector__select"
                        name=""
                        :id="'selectedCoursePlus_' + index"
                        required
                        v-on:change="updateSelectedCourses($event, index)">

                        <option class="courseSelector__option" value="0" selected>{{ $t("formDefaultOptionCoursePlus")}} {{ index +1 }}. {{ $t("choice")}}</option>
                        <option class="courseSelector__option"
                            v-for="course in courses"
                            :key="course.id"
                            :value="course.id"
                            :disabled="courseIsSelected(course.id)"
                            :selected="selectedCourse == course.id">
                            {{ getCourseName(course.id) }}
                        </option>
                    </select>
                </div>
                <div v-if="showAddCourse">
                    <button class="form__input-add-button"
                        v-on:click="addCourse()">{{$t("formButtonAddCourse")}}</button>
                    <div>
                        <span class="form__explanation">
                            {{$t('formExplanationCourse')}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        'courses',
        'locale',
        'selectedCourses'
    ],
    emits: [
        'updateSelectedCourses',
    ],
    data() {
        return{

        }
    },
    methods: {
        addCourse() {
            const maxLength = Math.min(this.courses.length, 4);
            if (this.selectedCourses.includes(0) || this.selectedCourses.length == maxLength) {
                return;
            }

            this.selectedCourses.push(0);
        },
        courseIsSelected(courseId){
            return this.selectedCourses.includes(courseId);
        },
        updateSelectedCourses(event = null, index = null) {
            if (event) {
                const select = event.target;
                const i      = parseInt(select.id.split('_')[1]);
                const course = select.value;
                if (index !== null
                    && this.selectedCourses[index] !== null
                    && this.selectedCourses[index] != parseInt(course)) {
                    this.selectedCourses[index] = parseInt(course);
                } else if (!this.selectedCourses.includes(parseInt(course))) {
                    this.selectedCourses.push(parseInt(course));
                }
            }

            this.$emit('updateSelectedCourses', this.selectedCourses);
        },
        getABYears() {
            const now = new Date();
            const year = now.getFullYear() + 1;
            const month = now.getMonth();

            if (month < 10) {
                return [year - 1, year];
            } else {
                return [year, year + 1];
            }
        },
        getCourseName(courseId) {
            let course = null;
            course = this.courses.find(course => course.id == courseId);

            // set name of course
            let courseName = "";
            if (this.locale === "no") {
                courseName = course.name_no;
            } else {
                courseName = course.name_en;
                if (courseName === null || courseName === "") {
                    courseName = course.name_no;
                }
            }

            return courseName;
        },

    },
    computed: {
        showAddCourse() {
            const maxLength = Math.min(this.courses?.length, 4)

            return this.selectedCourses.length < maxLength
                && !this.selectedCourses.includes(0);
        },
    },
    watch: {
        selectedCourses(){
            console.log(this.selectedCourses)
        }
    }
}
</script>